import type { TableSourceJS } from "target_wasm";
import { useBoundStore } from "components/canvas/stores/useAppStore";
import { useCheckpointsStore } from "stores/useCheckpointsStore";
import { isImportedSource } from "components/canvas/utils/roles";
import { showNotificationGlobal } from "stores/useNotificationStore";
import { tableStateRefusal } from "./items";

export type HistoryKind = "Checkpoints" | "Releases";

/** What a table's history is to this client: the releases an importer may
 *  restore, its checkpoints, or nothing — nothing on a table not yet, or no
 *  longer, there. */
export function historyOf(
  source: TableSourceJS,
  perms: { can_checkpoint?: boolean } | null | undefined,
): HistoryKind | null {
  if (tableStateRefusal(source)) return null;
  if (isImportedSource(source)) return "Releases";
  return perms?.can_checkpoint ? "Checkpoints" : null;
}

export function openCheckpoints(tableId: string, anchor?: HTMLElement): void {
  const { clientApp } = useBoundStore.getState();
  if (!clientApp) return;
  try {
    const table = clientApp.table_details_by_table_id(tableId);
    if (!historyOf(table.source, clientApp.peek_table_permissions(tableId)))
      return;
    useCheckpointsStore
      .getState()
      .show({ tableId, itemId: table.item_id, anchor });
  } catch {
    /* no table, no history */
  }
}

export function syncToLatestRelease(tableId: string): void {
  try {
    useBoundStore.getState().clientApp?.handle_update_table_to_latest(tableId);
    showNotificationGlobal("Syncing to the latest release…", "default");
  } catch {
    showNotificationGlobal("Failed to sync to the latest release.", "error");
  }
}
